import { startsWith, uniqueId } from 'lodash';
import FusionConstant from './FusionConstant';
import fusionConstant from './FusionConstant';

const { flex } = window;
const { React } = flex.lib;

function RegisterStep() {
    const {
        registerStep: {
            leftImgSrc: happyBunch,
            steps: introductionList
        }
    } = fusionConstant;

    const {
        headers: {
            Host: host
        }
    } = flex.getStore().appContext;

    const clickHandler = ({ href }) => {
        const urlProtocol = startsWith(window.location.href, 'https://')
            ? 'https://'
            : 'http://';

        flex.redirect(href || urlProtocol + host[0]);
    };

    return (
        <div className='fusion-landing__register-step'>
            <div className='fusion-landing__register-step__header'>
                <span>{FusionConstant.registerStep.header}</span>
            </div>
            <div className='fusion-landing__register-step__content'>
                <img src={happyBunch} alt='' width='400' />
                <dl>
                    {introductionList.map((item, index) => (
                        <React.Fragment key={uniqueId()}>
                            <dt onClick={() => clickHandler(item)}>
                                <svg height='26' width='26'>
                                    <circle cx='13' cy='13' r='13' strokeWidth='0' fill='#033568' />
                                    <polygon points='8,6 8,20 20,13' style={{ fill: 'white', strokeWidth: 0 }} />
                                </svg>
                                <span>{FusionConstant.registerStep.contentSpan + (index + 1)}</span>
                            </dt>
                            <dd onClick={() => clickHandler(item)}>
                                <div>
                                    {item.description.split('\n').map(text => (
                                        <p key={uniqueId()}>{text}</p>
                                    ))}
                                </div>
                            </dd>
                        </React.Fragment>
                    ))}
                </dl>
            </div>
        </div>
    );
}

module.exports = RegisterStep;
